module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 1rem 0",
      "height": "100%"
    }
  }, [_c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "我报名的比赛"
    },
    scopedSlots: _vm._u([{
      key: "right-icon",
      fn: function() {
        return [_c('div', {
          staticClass: "tiny-btn-1"
        }, [_vm._v("去认证")])]
      },
      proxy: true
    }])
  }), _vm._v(" "), (false) ? _c('van-cell', {
    attrs: {
      "title": "家长认证",
      "label": "上传身份证明信息，完成后自动关联子女运动员信息"
    },
    scopedSlots: _vm._u([{
      key: "right-icon",
      fn: function() {
        return [_c('div', {
          staticClass: "tiny-btn-1"
        }, [_vm._v("管理")])]
      },
      proxy: true
    }], null, false, 589936917)
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bottom-button"
  }, [_c('van-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'YundongyuanList'
      }),
      expression: "{name:'YundongyuanList'}"
    }],
    attrs: {
      "round": "",
      "type": "default"
    }
  }, [_vm._v("运动员管理")]), _vm._v(" "), _c('van-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'CaipanList'
      }),
      expression: "{name:'CaipanList'}"
    }],
    attrs: {
      "round": "",
      "type": "default"
    }
  }, [_vm._v("裁判员管理")]), _vm._v(" "), _c('van-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'JiaolianList'
      }),
      expression: "{name:'JiaolianList'}"
    }],
    attrs: {
      "round": "",
      "type": "default"
    }
  }, [_vm._v("教练员管理")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "10px"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5366dcdd","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/sai/MySai.vue
// module id = 1240
// module chunks = 0